<template>
  <page-header />
  <a-layout>
    <a-layout-content class="product-detail-container">
      <!-- 加载状态 -->
      <a-spin v-if="loading" size="large" class="loading" />
      <!-- 商品详情 -->
      <div v-else class="product-detail">
        <a-row :gutter="24">
          <!-- 商品主图 -->
          <a-col :span="12">
            <div class="product-image">
            <a-image
                :src="product.image"
                :alt="product.name"
                :fallback="imageErr"
            />
            </div>
          </a-col>

          <!-- 商品信息 -->
          <a-col :span="12">
            <div class="product-info">
              <h1 class="product-name">{{ product.name }}</h1>
              <div class="product-price">
                ¥{{ product.price.toFixed(2) }}
                <span v-if="product.kind !== 'text'" style="font-size: 0.6em">起</span>
              </div>
              <div class="product-category">
                <h3>商品类型：{{ kindTitle[product.kind] }}</h3>
              </div>
              <div v-if="!kindProductUsable.is_usable" class="product-auth">
                <a-tag color="green">还未购买</a-tag>
              </div>
            </div>
          </a-col>
        </a-row>

        <template v-if="product.kind === 'text'">
          <!-- 购买商品 -->
          <buy-product
              v-if="kindProductUsable.can_buy"
              :product="product"
              :kind_product="kindProductUsable.kind_product"
              @usableChange="fetchKindProductUsable()"
          />
          <!-- 商品描述 -->
          <product-description :detail="product.detail"></product-description>
          <usable-product-text
              v-if="kindProductUsable.is_usable"
              :product_text="kindProductUsable.kind_product"
          />
        </template>

        <template v-else-if="product.kind === 'point'">
          <usable-product-point
              v-if="kindProductUsable.is_usable"
              :product_point="kindProductUsable.kind_product"
              :deal="kindProductUsable.deal"
          />
          <!-- 购买商品 -->
          <buy-product
              v-if="kindProductUsable.can_buy"
              :product="product"
              :kind_product="kindProductUsable.kind_product"
              @usableChange="fetchKindProductUsable()"
          />
          <!-- 商品描述 -->
          <product-description :detail="product.detail"></product-description>
        </template>

        <template v-else-if="product.kind === 'subscription'">
          <usable-product-subscription
              v-if="kindProductUsable.is_usable"
              :product_subscription="kindProductUsable.kind_product"
              :deal="kindProductUsable.deal"
          />
          <!-- 购买商品 -->
          <buy-product
              v-if="kindProductUsable.can_buy"
              :product="product"
              :kind_product="kindProductUsable.kind_product"
              @usableChange="fetchKindProductUsable()"
          />
          <!-- 商品描述 -->
          <product-description :detail="product.detail"></product-description>
        </template>
      </div>
    </a-layout-content>
    <a-layout-footer :style="{ textAlign: 'center' }">
      <icp />
    </a-layout-footer>
  </a-layout>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import request from '@/utils/request';
import PageHeader from '@/components/header.vue'
import Icp from '@/components/icp.vue'
import { message } from 'ant-design-vue'
import imageErr from '@/assets/image_err.png'
import { BuyProduct, ProductDescription, UsableProductSubscription, UsableProductPoint, UsableProductText } from './components'

export default defineComponent({
  name: 'ProductDetail',
  components: {
    Icp,
    PageHeader,
    BuyProduct,
    ProductDescription,
    UsableProductSubscription,
    UsableProductPoint,
    UsableProductText
  },
  setup() {
    const route = useRoute();
    const loading = ref(true);
    const product = ref({
      id: 0,
      name: '',
      kind: '',
      image: '',
      price: 0,
      category: '',
      description: '',
      kind_product_id: 0,
    });
    const kindProductUsable = ref({
      is_usable: false,
      can_buy: true,
      kind_product: {},
      deal: {}
    });

    const kindTitle = ref({
      text: '文章',
      point: '点数',
      subscription: '订阅'
    });

    // 获取商品详情
    const fetchProductDetail = async () => {
      try {
        loading.value = true;
        const productId = route.query.id;
        const response = await request.get(`/product/detail/${productId}`);
        product.value = response.data || {};
      } catch (err) {
        console.error('获取商品详情失败:', err);
        message.error('获取商品详情失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };

    // 检查商品是否可用
    const fetchKindProductUsable = async () => {
      try {
        const productId = route.query.id;
        const response = await request.get(`/product/check_usable/kind_product/${productId}`);
        kindProductUsable.value = response.data || {};
        if (product.value.kind === 'point') {
          kindTitle.value.point = kindProductUsable.value.kind_product.point_name;
        }
      } catch (err) {
        // console.error('获取商品详情失败:', err);
      }
    };

    // 组件挂载时获取数据
    onMounted(() => {
      fetchProductDetail();
      fetchKindProductUsable();
    });

    return {
      loading,
      product,
      kindProductUsable,
      kindTitle,
      imageErr,
      fetchKindProductUsable,
    };
  }
});
</script>

<style src="./index.css" lang="css" scoped></style>
